import React from 'react';
import { Button, Icon } from 'antd';

function ForwardButton({
  title,
  disabled,
  loading,
  onClick,
  addonAfter,
  className,
  size
}: {
  title: string;
  disabled?: boolean;
  loading?: boolean;
  onClick: () => void;
  addonAfter?: JSX.Element | null;
  className?: string;
  size?: 'large' | 'small' | 'default';
}) {
  const forwardButtonStyle = {
    minWidth: '110px',
    margin: '10px',
    backgroundColor: '#50E3C2',
    border: 'none',
    color: 'white'
  };

  return (
    <Button
      onClick={onClick}
      style={{
        ...forwardButtonStyle,
        opacity: disabled || loading ? 0.5 : 1.0
      }}
      size={size}
      disabled={disabled}
      loading={loading}
      className={className}
    >
      <span style={{ color: 'white' }}>
        {title} {addonAfter}
      </span>
    </Button>
  );
}
ForwardButton.defaultProps = {
  addonAfter: <Icon type="arrow-right" style={{ marginLeft: '15px' }} />,
  size: 'large'
};
export default ForwardButton;
